// extracted by mini-css-extract-plugin
module.exports = {"supportIcon":"support_supportIcon__1s-Ln","title":"support_title__17P3F","paragraph":"support_paragraph__8VJG7"};